import type { GridProps} from '@chakra-ui/react'
import { chakra, Flex, Grid, Tooltip } from '@chakra-ui/react'

import { WarningIcon } from '../../../components/icons/WarningIcon'

export interface InsuranceInfoFormControlProps extends GridProps {
  label: string
  value?: string | null
  emptyLabel?: string
  hasError?: boolean
  errorMessage?: string | null,
  leftControl?: React.ReactNode
}

export const InsuranceInfoFormControl = ({
  children,
  label,
  value,
  emptyLabel,
  hasError = false,
  errorMessage,
  leftControl,
  ...rest
}: InsuranceInfoFormControlProps) => {
  return (
    <Grid
      sx={{
        gap: 0,
        alignItems: 'center',
        justifyContent: 'start',
        justifyItems: 'start',
        gridTemplateColumns: 'auto',
      }}
      {...rest}
    >
      <chakra.label
        sx={{
          color: 'insurance-info-label-color',
          fontSize: { base: 'xs', lg: 'sm' },
        }}
      >
        {label}
      </chakra.label>

      <Flex sx={{ gap: 4, py: 1 }}>
        {leftControl && leftControl}

        <chakra.span
          sx={{
            color: hasError ? 'red.500' : 'insurance-info-value-color',
            fontSize: 'sm',
            fontWeight: 'bold',
          }}
        >
          {value || emptyLabel}
        </chakra.span>

        {hasError && errorMessage && (
          <Tooltip label={errorMessage} hasArrow placement="top">
            <WarningIcon />
          </Tooltip>
        )}
      </Flex>
    </Grid>
  )
}